<mat-card>
    <mat-card-header>
        <mat-card-title>Cadastrar Unidade de Medida</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>
        <form [formGroup]="unidadeForm">
            <div class="row">
                <div class="col-auto">
                    <mat-form-field appearance="outline" [floatLabel]="'always'">
                        <mat-label>Nomeclatura</mat-label>
                        <input type="text" matInput formControlName="nomeUnidade" required maxlength="50">
                        <mat-error *ngIf="f.nomeUnidade.errors">
                            Campo obrigatório
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </mat-card-content>

    <mat-divider></mat-divider>

    <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
        <button mat-flat-button color="warn" (click)="limparCampos()">
            <mat-icon>clear</mat-icon> Limpar Campos
        </button>
        <button mat-flat-button color="primary" (click)="cadastrar()">
            <mat-icon>check</mat-icon> Cadastrar
        </button>
    </section>
</mat-card>